import * as TYPES from './_store/types';
import { dateFormat } from '../../common/format';

export async function getBlogs(
    store,
    { pageSize, categoryIds, publishTimeFormatFlag = true }
) {
    const autorefresh = true;
    const ids = '0';
    let res = await this.axiosIns.post('/api-graphql', {
        query: `{ blogListOnCategoryId(pageNum: 1, pageSize: ${pageSize}, categoryIds: "${categoryIds}", ids:"${
            autorefresh ? 0 : ids
        }"){ title, previewPicture, previewContent, publishTime, url, imageAltText } }`
    });
    if (publishTimeFormatFlag) {
        return fillPublishTimeFormat.call(this, res.data?.blogListOnCategoryId || []);
    }
    return res;
}
function fillPublishTimeFormat(list = []) {
    return list.map(v => {
        v.publishTimeFormat =
            v.publishTime &&
            dateFormat('MMMM dd, yyyy hh:mm p', new Date(+v.publishTime), this.$pinia);
        return v;
    });
}

export async function asyncData(store) {
    let listing = await getBlogs.call(this, store, {
        pageSize: this.blogNum || 3,
        categoryIds: this.categoryId || 0
    });
    store[TYPES.SET_LISTING](listing);
    const isShow = !this.isMobileSize && listing.length > this.showCardNum
    store[TYPES.SET_SLIDER_BTNS](isShow);
}
